module.exports = __webpack_public_path__ + "static/media/demo-card.44272346.wav";